import { createViewHandler } from './CreateViewStmt';
import { removeViewHandler } from './RemoveViewStmt';
import { renameViewHandler } from './RenameViewStmt';
export * from './CreateViewStmt';
export * from './RemoveViewStmt';
export * from './RenameViewStmt';
export * from './viewInstruction';
export const viewHandlers = [createViewHandler, removeViewHandler, renameViewHandler];
//# sourceMappingURL=index.js.map